import * as React from 'react';
import * as _ from 'underscore';

import { BrowserTitleService } from '~commonInfra/services/BrowserTitleService';

import { Messages } from '../../../codegen/Localize';
import { fetch,ILicensingInfoWithTotals } from '../../../ts/services/LicensesService';
import { RouterError } from '../RouterHelpers/RouterError';
import { renderLicenseTabComponent } from './LicenseTabComponent';



export interface LicensesSettingsSubspaceState {
  readonly hasDataToRender: boolean;
  readonly hasError: boolean;
  readonly licensingInfo: ILicensingInfoWithTotals;
}

export class LicensesSettingsSubspace extends React.PureComponent<{}, LicensesSettingsSubspaceState> {

  private unmounted: boolean = false;

  public constructor(props: any) {
    super(props);
    this.state = {hasDataToRender: false, hasError: false, licensingInfo: undefined};
    BrowserTitleService.setTitleWithTranslatedSpace({translatedSpaceName: Messages.serverSettings_licenses()});
  }

  public componentDidMount() {
    this.getData();
  }

  public componentWillUnmount() {
    this.unmounted = true;
  }

  public componentDidUpdate() {
    if (!_.isUndefined(this.state.licensingInfo)) {
        this.updateState({hasDataToRender: true});
    }
  }

  public render() {
    if (!this.state.hasDataToRender) {
      return null;
    } else if (this.state.hasError) {
      return <RouterError errorType={'server-default'} urls={undefined}/>;
    }

    return (
      <div className={'tb-stylish-settings'}>
        {renderLicenseTabComponent(this.state.licensingInfo)}
      </div>
    );
  }

  private updateState<K extends keyof LicensesSettingsSubspaceState>(newState: Pick<LicensesSettingsSubspaceState, K>, callback?: () => void): void {
    if (!this.unmounted) {
      this.setState(newState, callback);
    }
  }

  private getData() {
    this.getlicensingInfo();
  }

  private getlicensingInfo = async () => {
    try {
      const licensingInfo = await fetch();
      this.updateState({licensingInfo});
    } catch (e) {
      this.updateState({hasError: true});
    }
  }
}
